<template>
<div class="chapter">
<div class="inner_page">
<div>
<h2 class="fm_head" id="_idParaDest-2"><a id="_idTextAnchor001"></a><a href="#/text/9780062568144_Contents#r_idParaDest-2"><span class="right_1" epub:type="pagebreak" id="page_vii" title="vii">Epigraph</span></a></h2>
<p class="indent"><i>And I asked myself about the present; how wide it was, how deep it was, how much was mine to keep.</i></p>
<p class="epig_r"><i>—Kurt Vonnegut</i></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062568144_Epigraph.vue?1ef9e200